// src/components/DateSelectors.js
import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import DateRangeIcon from "@mui/icons-material/DateRange";
import DatePicker from "react-datepicker";
import { format } from "date-fns";

const DateSelectors = ({
  formData,
  ticketData,
  setFormData,
  setTicketData,
  raiseTicket,
}) => {

  const handleSelectDate = (date) => {
    const updatedFormData = {
      ...ticketData,
      targetDate: date,
    };
    console.log(ticketData)
    setTicketData(updatedFormData);
    raiseTicket(updatedFormData);
  };

  const handleSelectDateTime = (field, value) => {
    const updatedFormData = {
      ...formData,
      [field]: value ? value.toISOString() : null, // store as ISO string
    };

    setFormData(updatedFormData);
    console.log("Updated formData:", updatedFormData);

    raiseTicket(updatedFormData);
  };

  return (
    <Grid container spacing={1}>
      {/* Plan Start Date */}
      <Grid item xs={2}>
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <Typography
            component="div"
            variant="body2"
            color="black"
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: 500,
              mb: 0.5,
            }}
          >
            <DateRangeIcon color="action" sx={{ fontSize: 18, mr: 0.5 }} />
            Plan Start Date
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderRadius: "6px",
              padding: "0px 10px",
              cursor: "pointer",
              height: "35px",
              "&:hover": {
                borderColor: "#1976d2",
                backgroundColor: "#f0f7ff",
              },
            }}
          >
            <DatePicker
              selected={formData.startDateTime ? new Date(formData.startDateTime) : null}
              onChange={(date) => handleSelectDateTime("startDateTime", date)}
              dateFormat="dd-MM-yyyy HH:mm"
              showTimeSelect
              timeIntervals={1}
              popperPlacement="right"
              customInput={
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "14px",
                    color: formData.startDateTime ? "text.primary" : "text.secondary",
                    width: "100%",
                  }}
                >
                  {formData.startDateTime
                    ? format(formData.startDateTime, "dd-MM-yyyy HH:mm")
                    : "Start Date"}
                </Typography>
              }
            />
          </Box>
        </Box>
      </Grid>

      {/* Plan End Date */}
      <Grid item xs={2}>
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <Typography
            component="div"
            variant="body2"
            color="black"
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: 500,
              mb: 0.5,
            }}
          >
            <DateRangeIcon color="action" sx={{ fontSize: 18, mr: 0.5 }} />
            Plan End Date
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              borderRadius: "6px",
              padding: "0px 10px",
              cursor: "pointer",
              height: "35px",
              "&:hover": {
                borderColor: "#1976d2",
                backgroundColor: "#f0f7ff",
              },
            }}
          >
            <DatePicker
              selected={formData.endDateTime ? new Date(formData.endDateTime) : null}
              onChange={(date) => handleSelectDateTime("endDateTime", date)}
              dateFormat="dd-MM-yyyy HH:mm"
              showTimeSelect
              timeIntervals={1}
              popperPlacement="right"
              customInput={
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "14px",
                    color: formData.endDateTime ? "text.primary" : "text.secondary",
                    width: "100%",
                  }}
                >
                  {formData.endDateTime
                    ? format(formData.endDateTime, "dd-MM-yyyy HH:mm")
                    : "End Date "}
                </Typography>
              }
            />
          </Box>
        </Box>
      </Grid>

      {/* Empty space */}
      <Grid item xs={6}></Grid>

      {/* Target Date */}
      <Grid item xs={2}>
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <Typography
            component="div"
            variant="body2"
            color="black"
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: 500,
              mb: 0.5,
            }}
          >
            <DateRangeIcon color="action" sx={{ fontSize: 18, mr: 0.5 }} />
            Target Date
          </Typography>

          <DatePicker
            selected={ticketData.targetDate}
            onChange={handleSelectDate}
            dateFormat="dd-MM-yyyy"
            popperPlacement="left"
            customInput={
              <Grid container alignItems="center" sx={{ flex: 1 }}>
                <Grid item xs>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "14px",
                      color: ticketData.targetDate ? "text.primary" : "text.secondary",
                    }}
                  >
                    {ticketData.targetDate
                      ? format(ticketData.targetDate, "dd-MM-yyyy")
                      : "Target Date"}
                  </Typography>
                </Grid>
              </Grid>
            }
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default DateSelectors;
